<div class="form-container box">
  <div class="title" [translate]="'HEADER.INVITE_FORM.TITLE'"></div>
  <div class="subtitle" [translate]="'HEADER.INVITE_FORM.SUBTITLE'"></div>
  @if(inviteForm){
    <form [formGroup]="inviteForm">
      <div class="form-group">
        <label [translate]="'HEADER.INVITE_FORM.NAME'"></label>
        <input class="form-control" placeholder="{{ 'HEADER.INVITE_FORM.PLACEHOLDERS.USER' | translate }}"
          formControlName="name">
          @if(inviteForm.controls['name'].invalid && inviteForm.controls['name'].touched){

            <span class="validation-text" 
              [translate]="'HEADER.INVITE_FORM.ERRORS.INVALID_NAME'"></span>
          }
      </div>
      <div class="form-group">
        <label [translate]="'HEADER.INVITE_FORM.EMAIL'"></label>
        <input class="form-control" placeholder="{{ 'HEADER.INVITE_FORM.PLACEHOLDERS.EMAIL' | translate }}"
          formControlName="email">
          @if(inviteForm.controls['email'].invalid && inviteForm.controls['email'].touched){
            <span class="validation-text"
              [translate]="'HEADER.INVITE_FORM.ERRORS.INVALID_EMAIL'"></span>
          }
      </div>
    </form>
  }
  <div class="buttons-container">
    <button class="btn btn-primary outline" (click)="closeForm()"
      [translate]="'HEADER.INVITE_FORM.BUTTONS.CANCEL'"></button>
    <button class="btn btn-primary" (click)="sendInvitation()" [translate]="'HEADER.INVITE_FORM.BUTTONS.INVITE'"></button>
  </div>
</div>
